import {
  startCollectingRequests as publicStartCollectingRequests,
  stopCollectingRequests as publicStopCollectingRequests,
  getSettings as publicGetSettings,
} from './ecom-v1-back-in-stock-settings-back-in-stock-settings.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const startCollectingRequests: MaybeContext<
  BuildRESTFunction<typeof publicStartCollectingRequests> &
    typeof publicStartCollectingRequests
> = /*#__PURE__*/ createRESTModule(publicStartCollectingRequests);
export const stopCollectingRequests: MaybeContext<
  BuildRESTFunction<typeof publicStopCollectingRequests> &
    typeof publicStopCollectingRequests
> = /*#__PURE__*/ createRESTModule(publicStopCollectingRequests);
export const getSettings: MaybeContext<
  BuildRESTFunction<typeof publicGetSettings> & typeof publicGetSettings
> = /*#__PURE__*/ createRESTModule(publicGetSettings);

export {
  BackInStockSettings,
  BackInStockCollectionState,
  StartCollectingRequestsRequest,
  StartCollectingRequestsResponse,
  StopCollectingRequestsRequest,
  StopCollectingRequestsResponse,
  GetSettingsRequest,
  GetSettingsResponse,
  StartCollectingRequestsResponseNonNullableFields,
  StopCollectingRequestsResponseNonNullableFields,
  GetSettingsResponseNonNullableFields,
} from './ecom-v1-back-in-stock-settings-back-in-stock-settings.universal.js';
